import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { getWebsiteRate, patchWebsiteRate, createWebsiteRate } from './Api';

const WebRateModal = ({ show, onHide }) => {
  const [rate, setRate] = useState(0);
  const [comment, setComment] = useState('');
  const [hasRated, setHasRated] = useState(false);
  const [loading, setLoading] = useState(false);

  // Prefill modal with existing rate if available
  useEffect(() => {
    if (show) {
      setLoading(true);
      getWebsiteRate()
        .then(data => {
          if (data && typeof data.rate === 'number') {
            setRate(data.rate);
            setComment(data.comment || '');
            setHasRated(true);
          } else {
            setRate(0);
            setComment('');
            setHasRated(false);
          }
        })
        .catch(() => {
          setRate(0);
          setComment('');
          setHasRated(false);
        })
        .finally(() => setLoading(false));
    }
  }, [show]);

  const handleStarClick = (star) => setRate(star);

  const handleSend = async () => {
    setLoading(true);
    try {
      if (hasRated) {
        await patchWebsiteRate({ rate, comment });
      } else {
        await createWebsiteRate({ rate, comment });
      }
      setRate(0);
      setComment('');
      setHasRated(true);
      onHide();
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body style={{ background: '#fff', borderRadius: '12px', textAlign: 'center' }}>
        <button
          type="button"
          className="btn-close position-absolute end-0 mt-2 me-2"
          aria-label="Close"
          onClick={onHide}
          style={{ zIndex: 2 }}
        />
        <h4 className="mb-3 mt-2 fw-bold" style={{ color: '#ff6600' }}>Please rate us</h4>
        <div className="mb-3">
          {[1, 2, 3, 4, 5].map((star) => (
            <span
              key={star}
              style={{
                fontSize: '2rem',
                color: rate >= star ? '#ff6600' : '#ddd',
                cursor: 'pointer',
                marginRight: '4px'
              }}
              onClick={() => handleStarClick(star)}
              role="button"
              aria-label={`Rate ${star} star${star > 1 ? 's' : ''}`}
            >
              ★
            </span>
          ))}
        </div>
        <textarea
          className="form-control mb-3"
          style={{ background: '#f8f9fa', border: '1px solid #eee', color: '#333' }}
          rows={3}
          placeholder="Leave a comment..."
          value={comment}
          onChange={e => setComment(e.target.value)}
        />
        <Button
          variant="light"
          style={{
            background: '#fff',
            color: '#ff6600',
            border: '2px solid #ff6600',
            fontWeight: 'bold',
            borderRadius: '8px',
            width: '120px'
          }}
          onClick={handleSend}
          disabled={rate === 0 || loading}
        >
          {hasRated ? 'Update' : 'Send now'}
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default WebRateModal;